export const RX = 'rx';
export const TX = 'tx';
export const BOOLEAN = 'Boolean';
export const INTEGER = 'Integer';
export const STRING = 'String';
export const LIST = 'List';
export const RANGE = 'Range';
export const CORNER = 'Corner';
export const TAP = 'Tap';
export const FLOAT = 'Float';
export const GAUSSIAN = "Gaussian";
export const PARAMETER_DUAL_DIRAC = "Dual-Dirac";
export const PARAMETER_DJRJ = "DjRj";
export const IBIS_ODT = "0";
export const CUSTOM_ODT = "1";
export const IBIS_AMI_FILE_MODEL = "0";
export const AMI_OBJ_PARAM = "1";